import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import { useDispatch, useSelector } from 'react-redux'
import { InitialState } from './types'
import * as actions from './actions'
import moment from 'moment'

// Styles
import './styles.scss'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import LoadingPage from '../../components/LoadingPage'
import Loading from '../../components/Loading'

export default () => {
  const [mounted, setMounted] = useState<boolean>(false)

  const { users, meta, isProcessFetching, error } = useSelector(
    (state: { adminUsers: InitialState }) => state.adminUsers
  )

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(actions.destroy())
    dispatch(actions.fetchUsers(1))
    setMounted(true)
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  const name = (
    firstName?: string,
    middleName?: string,
    lastName?: string
  ): JSX.Element => {
    const fio = [firstName, middleName, lastName].filter(i => i)
    return fio.length ? (
      <span style={{ color: 'blue' }}>{fio.join(' ')}</span>
    ) : (
      <span style={{ color: 'grey' }}>Имя не заполнено</span>
    )
  }

  return (
    <>
      <Header />
      <div className={'container'}>
        {!mounted || !users ? (
          <LoadingPage />
        ) : (
          <>
            <h2>Панель администрирования - Пользователи</h2>
            <table style={{ width: '100%' }}>
              <thead>
                <tr>
                  <td>
                    <b>ФИО</b>
                  </td>
                  <td>
                    <b>Email</b>
                  </td>
                  <td>
                    <b>Дата регистрации</b>
                  </td>
                </tr>
              </thead>
              <tbody>
                {users.map(user => (
                  <tr key={user.user_id}>
                    <td>
                      <Link
                        style={{ color: 'black' }}
                        to={`/admin/users/${user.user_id}`}
                      >
                        {name(
                          user.profile.first_name,
                          user.profile.middle_name,
                          user.profile.last_name
                        )}
                      </Link>
                    </td>
                    <td>{user.profile.contact_email || ''}</td>
                    <td>
                      {moment(user.profile.created_at).format('LLLL') || ''}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {meta ? (
              <div className={'pagination-outer'}>
                <ReactPaginate
                  previousLabel={'<'}
                  nextLabel={'>'}
                  breakClassName={'break-me'}
                  pageCount={meta.last_page}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={page =>
                    dispatch(actions.fetchUsers(page.selected + 1))
                  }
                  containerClassName={'pagination'}
                  activeClassName={'active'}
                />
                {isProcessFetching ? (
                  <Loading width={30} height={30} color={'#1978B2'} />
                ) : null}
              </div>
            ) : null}
          </>
        )}
        <span style={{ color: 'red' }}>{error}</span>
      </div>
      <Footer />
    </>
  )
}
